<template>
  <div class="consentagree">
    <div class="header">
      <enterprise-header></enterprise-header>
    </div>
    <div class="content">
      <div class="main">
        <div style="width:1280px;height:828px;background:#ffffffcf;margin:17px auto;margin-bottom:0;border-radius: 4px">
          <div>
            <div style="margin:0 auto;padding-top:105px;height:32px;">
              <steps ref="stepsChild" :width="width"></steps>
            </div>
            <div style="width:1066px;margin:0 auto;margin-top:68px">
              <p style="font-size:16px;color:var(--key-color);">
                欢迎您使用{{ $appTitle }}！
              </p>
              <p style="font-size:14px;color:var(--key-color);margin-top:26px">
                创建企业是一项严肃的法律行为，请确认在创建企业之前已仔细阅读并同意以下内容及《{{ $appTitle }}平台企业服务协议》。
              </p>
              <p style="font-size:14px;color:var(--key-color);margin-top:18px">
                1.
                在帐号资质审核成功之后，帐号的使⽤权属于通过资质审核的拟认证主体，该帐号⾃注册时其产⽣的⼀切权利义务均由该主体承担，该帐号所获得的所有收益、权限均归认证后的主体享有，且所有运营活动都必须以该主体对外开展。
              </p>
              <p style="font-size:14px;color:var(--key-color);margin-top:24px">
                2.
                认证主体提交给腾讯的认证资料真实⽆误，并不可撤销地授权腾讯及其委托的任何第三⽅审核机构对提交的资料进⾏甄别核实，⼀经申请即产⽣腾讯及其委托的第三⽅审核机构的审核成本，故所交纳的认证审核服务费⽤将不因认证结果、拟认证主体是否提出撤回申请等因素⽽退回。
              </p>
              <p style="font-size:14px;color:var(--key-color);margin-top:27px">
                3.
                拟认证主体在申请微信认证服务过程中填写并向腾讯提交的认证联系⼈（包括后续不时变更的⼈员）为拟认证主体指定的认证联系⼈员，并特此授权由该指定⼈员以拟认证主体的名义负责该微信帐号的内容维护、开发维护及运营管理。认证联系人的所有操作行为，均代表拟认证主体，拟认证主体均需承担一切责任。
              </p>
              <p style="font-size:14px;color:var(--key-color);margin-top:27px">
                4.
                本认证服务仅对该帐号所提交的认证资料的真实性、合法性进⾏书⾯甄别核实，其功能、权限是否开通、帐号能否发布等均需遵守对应业务平台为此所制定的专项规（如微信公众号须遵循《微信公众平台服务协议》；微信小程序帐号须遵循《微信公众平台服务协议》及《微信⼩程序平台服务条款》；微信开放平台帐号须遵循《微信开放平台开发者服务协议》），⽽不与认证审核结果存在直接关联。
              </p>
              <p style="font-size:14px;color:var(--key-color);margin-top:27px">
                5.
                拟认证主体如违反上述承诺，均需承担一切责任，对腾讯或第三方造成损失的，须赔偿损失。在微信同意通过新的认证服务之前，本公函持续有效。
              </p>
              <el-checkbox v-model="checked" style="margin-top:34px;font-size:14px;color:var(--key-color)">
                我已同意并遵守上述内容及《{{ $appTitle }}平台企业服务协议》。
              </el-checkbox>
            </div>
            <div class="foot">
              <el-button type="primary" size="small" plain @click="goenterprise">
                上一步
              </el-button>
              <el-button type="primary" size="small" @click="validationsuccee">
                下一步
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import steps from "@/CommonDP/components/steps";
import EnterpriseHeader from "./components/userEnterHeader";
import { storage } from '@/CommonDP/utils';
export default {
  components: {
    steps,
    EnterpriseHeader
  },
  data() {
    return {
      width: "319",
      stepsIndex: 0,
      stepsData: [{ name: "同意协议" }, { name: "填写资料" }, { name: "创建完成" }],
      checked: false,
      greetype: "" // 后面拼接的是来自那个页面的路由  用户中心跳过来的 跳回用户中心 注册跳过来的 跳回注册 等等等
    };
  },
  created() {
    this.checked = JSON.parse(storage.get("setchecked"));
    if (this.$route.query.greetype) {
      this.greetype = this.$route.query.greetype;
    }
  },
  methods: {
    goenterprise() {
      // 从无企业页面跳过来的 或者注册时候跳过来的
      if (this.$route.query.greetype == "enterprisepage") {
        // 返回无企业页面
        this.$router.replace({ path: "/enterprisepage", query: { pagetype: this.$route.query.pagetype }});
      } else {
        storage.set("stepsIndex", 2);
        this.$router.push({ name: "register" });
      }
    },
    // 下一步
    validationsuccee() {
      if (this.checked) {
        var params = {
          enterpriseName: "",
          creditCode: "",
          userName: "",
          idCard: "",
          verifyCode: "",
          fileList1: [],
          fileList2: []
        };
        storage.set("setenterpriseForm", JSON.stringify(params));
        storage.set("setchecked", JSON.stringify(this.checked));
        // this.$route.query.greetype=='enterprisepage'代表来自无企业
        if (this.$route.query.greetype == "enterprisepage") {
          // fftype 0 代表不是重新填写 enterprisepagetype防止再下一个页面 点击上一步返回
          this.$router.replace({
            path: "/fillinformation",
            query: { fftype: "0", greetype: this.$route.query.greetype, pagetype: this.$route.query.pagetype }
          });
        } else {
          // 来自注册
          this.$router.replace({ path: "/fillinformation", query: { fftype: "0" }});
        }
      } else {
        this.$message({ message: "请勾选同意后再进行下一步", type: "warning" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.consentagree {
  min-width: 1275px;
  width: 100%;
  min-height: 937px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  .header {
    width: 100%;
    height: 68px;
    line-height: 68px;
    overflow: hidden;
    position: absolute;
    top: 0;
    text-align: center;
    box-sizing: border-box;
  }
  .content {
    position: absolute !important;
    position: relative;
    top: 68px !important;
    bottom: 0px;
    width: 100%;
    overflow: hidden;
    height: auto !important;
    left: 0px;
  }
  .main {
    height: 100%;
    min-height: 1000px;
    overflow-y: auto;
    background: url("../../assets/enterprise/qiye.png") no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    .foot {
      text-align: center;
      margin-top: 118px;
    }
  }
}
</style>
